(function (global, factory) {
  if (typeof define === 'function' && define.amd) {
    define(['exports', 'module', './lib/Base64'], factory);
  } else if (typeof exports !== 'undefined' && typeof module !== 'undefined') {
    factory(exports, module, require('./lib/Base64'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, mod, global.Base64);
    global.Checker = mod.exports;
  }
})(this, function (exports, module, _libBase64) {
  'use strict';

  var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

  var _Base64 = _interopRequireDefault(_libBase64);

  var Checker = (function () {
    function Checker(privateKey, license) {
      _classCallCheck(this, Checker);

      this.privateKey = privateKey;
      try {
        this.license = JSON.parse(Checker.decrypt(license, privateKey, true));
      } catch (e) {
        throw new Error('cannot parse license', e);
      }
    }

    _createClass(Checker, [{
      key: 'isLicenseValid',
      value: function isLicenseValid() {
        var valid = true;
        var now = new Date();
        if (Checker._def(this.license.startDate)) {
          if (new Date(this.license.startDate) > now) {
            valid = false;
          }
        }
        if (Checker._def(this.license.endDate)) {
          if (new Date(this.license.endDate) < now) {
            valid = false;
          }
        }
        if (Checker._def(this.license.domain)) {
          var domainRegex = new RegExp(this.license.domain, 'i');
          if (!domainRegex.test(window.location.hostname)) {
            valid = false;
          }
        }
        return valid;
      }
    }, {
      key: 'isModuleLicensed',
      value: function isModuleLicensed(moduleName) {
        return this.getModules().indexOf(moduleName) > -1;
      }
    }, {
      key: 'getModules',
      value: function getModules() {
        return this.license.modules || [];
      }
    }, {
      key: 'decryptFunction',
      value: function decryptFunction(hash) {
        return Checker.decrypt(hash, this.privateKey, false);
      }
    }], [{
      key: 'decryptFunctionOfModule',
      value: function decryptFunctionOfModule(hash, moduleName) {
        return Checker.decrypt(hash, moduleName, false);
      }
    }, {
      key: 'decrypt',
      value: function decrypt(str, pSalt, objectFix) {
        if (!str) {
          throw new Error('license is empty');
        }

        var salt = str.substr(0, 4) + str.substr(str.length - 4);
        var strArr = _Base64['default'].decode(_Base64['default'].decode(str.substr(4, str.length - 8)).substr(salt.length)).split('');
        for (var i = 0; i < strArr.length; i++) {
          strArr[i] = strArr[i].charCodeAt(0);
          if (Checker._def(pSalt)) {
            strArr[i] = strArr[i] ^ pSalt[i % pSalt.length].charCodeAt(0);
          }
          strArr[i] = ~(strArr[i] ^ i) ^ strArr.length - i;
          strArr[i] = String.fromCharCode(strArr[i]);
        }
        strArr = strArr.reverse();
        if (objectFix) {
          strArr[0] = '{';
        }
        return strArr.join('');
      }
    }, {
      key: '_def',
      value: function _def(variable) {
        return null !== variable && typeof variable !== 'undefined';
      }
    }]);

    return Checker;
  })();

  module.exports = Checker;
});
//# sourceMappingURL=Checker.js.map
